<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Shipping Method
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>
      
          <div class="nav-tree">
            <el-button @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Shipping Method</el-button>
          </div>

          <el-table
            max-height="720"
            :data="tableData"
            :empty-text="$t('general_noData')"
            style="width: 100%">
              <el-table-column
                label="ID"
                type="index"
                width="50">
              </el-table-column>
              <el-table-column
                prop="code"
                width="150"
                :label="$t('settings_accountThink_paymentMethods_code')">
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('settings_accountThink_paymentMethods_name')">
              </el-table-column>
              <el-table-column
                prop="createdDate"
                :label="$t('settings_accountThink_paymentMethods_createDate')"
                width="150">
              </el-table-column>
              <el-table-column
                width="120"
                :label="$t('settings_accountThink_paymentMethods_operations')">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    plain
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row)"></el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
          </el-table>

        </div>
      </div>
    </div>
    
    <!-- add -->
    <sweet-modal blocking title="Add Shipping Method" ref="openModal" class="modal" v-on:close="closeModal">
      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="name">
          <el-input :label="$t('settings_accountThink_paymentMethods_name')" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input :label="$t('settings_accountThink_paymentMethods_code')" v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
          <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

    <!-- edit -->
    <sweet-modal blocking title="Edit Shipping Method" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">
      <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
        <el-form-item prop="name">
          <el-input :label="$t('settings_accountThink_paymentMethods_name')" v-model="formEdit.name"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input :label="$t('settings_accountThink_paymentMethods_code')" v-model="formEdit.code"></el-input>
        </el-form-item>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
          <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

  </div>
</template>

<script>
let moment = require('moment')
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

export default {
  name: 'company-payment-methods',
  components: {
    SweetModal,
  },
  created () {
    this.loadList()
  },
  data() {
    return {
      tableData: [],
      selectedRowId: '',
      moment:moment,
      form:{
        name: '',
        code: ''
      },
      formEdit:{
        name: '',
        code: ''
      },
      rules: {
        name: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
      },
      rulesEdit: {
        name: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    loadList(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/shipping-method/list?companyId=${this.$route.query.companyId}`)
        .then(response => {
          this.tableData = response.data.list
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    openModalAdd(){
      this.$refs.openModal.open()
    },
    addItem(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/shipping-method/create`, {
              companyId: this.$route.query.companyId,
              code: this.form.code,
              name: this.form.name
            })
            .then(response => {
              this.$refs.openModal.close()
              this.loadList()
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleEdit(index, row) {
      this.selectedRowId = row.id
      let loader = this.$loading.show();
      let Id = 'projectTaskExpsensePaymentMethodId'
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/shipping-method/item?id=${row.id}`)
        .then(response => {
          this.$refs.openModalEdit.open()
          this.formEdit.name = response.data.item.name
          this.formEdit.code = response.data.item.code
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          console.log('An error occurred:', error);
        });
    },
    editItem(formEdit){
      this.$refs[formEdit].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          let Id = 'projectTaskExpsensePaymentMethodId'
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/shipping-method/update?id=${this.selectedRowId}`, {
              code: this.formEdit.code,
              name: this.formEdit.name
            })
            .then(response => {
              this.$refs.openModalEdit.close()
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              loader.hide()
              console.log('An error occurred:', error);
            });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleDelete(index, row) {
      console.log(row.id)
      // this.$refs.confirmation.open()
      this.selectedRowId = row.id
      console.log(row)

      this.$confirm('This will permanently delete the vendor. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed'
        });

        let Id = 'projectTaskExpsensePaymentMethodId'
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/shipping-method/delete?id=${this.selectedRowId}`)
          .then(response => {
            // this.$refs.confirmation.close()
            this.loadList()
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    closeModal(){
      this.form.name = ''
      this.form.code = ''
      this.$refs['form'].resetFields();
    },
    closeModalEdit(){
      this.formEdit.name = ''
      this.formEdit.code = ''
      this.$refs['formEdit'].resetFields();
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
  watch:{
    tableData(val){
      val.forEach(i =>{
        i.createdDate = moment(i.createdDate).format('D MMM YY')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>